import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ApiService } from "../app/services/api.service";
import { NavigationService } from './services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  environment = environment.production ? this.api.versionCorp : 'Desarrollo';

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public api: ApiService,
    private navigationService: NavigationService
  ) {
    this.platform.ready().then(() => {
      // 1) lee la ruta REAL del navegador
      const currentPath = window.location.pathname;

      // 2) solo restaurar si estás en raíz o en login
      if (currentPath === '/' || currentPath === '/login') {
        // pequeño defer para no competir con la navegación inicial
        setTimeout(() => this.navigationService.restoreLastRoute(), 0);
      }

      // (opcional) si usas estos plugins nativos, mantén tu init
      // this.statusBar.styleDefault();
      // this.splashScreen.hide();
    });
  }
}